<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                {{ $t('Results per page') }}
              </h6>
              <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                <span aria-hidden="true">
                    <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                    </cancel-icon>
                </span>
              </button>
            </div>
            <div class="modal-body">
                <div class="h-100" style="overflow:auto" ref="generalTab">
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                        <div>
                            <label>{{$t('Page Size')}}</label>
                        </div>
                        <input v-model="perPageValue" ref="fieldPerPage" placeholder="Enter name" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                        <span class="helper-tag">{{$t('Maximum Allowed : 100')}}</span>
                    </div>
              </div>
            </div>
            <div class="modal-footer p-0 primary-btn-style" style="padding-inline-end:10px !important;">
              <button class="btn btn-outline-secondary" data-dismiss="modal" @click.prevent="closeDialog()">{{$t('Cancel')}}</button>
              <button class="btn btn-outline-primary" @click.prevent="updatePerPageValue()">
                {{$t('Save')}}
              </button>
            </div>
          </div>
        </div>
    </div>
</template>
    
    
<script>
    import CancelIcon from "../core/InlineCancelField.vue";
    
    export default {
      data: () => ({
        perPageValue : 50,
      }),
      components:{
        'cancel-icon':CancelIcon
      },
      methods:{
          closeDialog(){
              this.perPageValue = "";
              this.$emit("close");
          },
          
          updatePerPageValue(){
                if(this.perPageValue >100){
                    alert(this.$t('Maximum allowed per page value is 100'));
                    return false;
                }
              if(this.perPageValue && this.perPageValue > 0){
                localStorage.setItem("perPageValue", this.perPageValue);
                  this.$emit("updatePerPageValue",this.perPageValue);
                  this.closeDialog();
              }
          },
      },
      created(){
        this.perPageValue = localStorage.getItem("perPageValue") || 50;
      },
      mounted(){
        this.$refs.fieldPerPage.focus();
      }
    }
  </script>
    
  <style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    .modal-dialog {
        max-width: 400px;
        width: 400px;
        margin: 0;
        padding: 0;
      }
      
      .modal-content {
        // height: 227px;
        height: 260px;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          padding: 6px;
          height:400px;
          overflow: auto;
        }
      }
    
    .modal {
      text-align: center;
      padding: 0!important;
      display:inline-flex !important;
      align-items: center;
      justify-content: center;
    }
    .modal-header .close {
      margin:0px !important;
      padding:2px !important;
    }
    .modal-header{
      padding: 4px 10px;
    }
    .modal:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-inline-end: -4px;
    }
    .modal-dialog {
      display: inline-block;
      text-align: start;
      vertical-align: middle;
    }

    .modal:before {
      content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        align-items: center;
        .modal-title{
          color:$text-color;
        }
    }

    .modal-footer{
        padding:10px 0px !important;
    }
     
    .primary-btn-style{
        margin-top:1%;
        button{
            height: 35px;
            width: 75px;
            font-size:14px;
        }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }
    
    .key-style {
      color: $dull-text-color;
      width: 30%;
      text-align: start;
      font-size: $input-field-and-label-font-size;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    
    .input-fields {
      border: none !important;
      border-bottom: 1px solid $active-blue !important;
      height:30px;
    }
    
    .input-fields:focus {
      outline: unset;
      box-shadow:none;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .config-desc{
      color: $dull-text-color;
      font-size:12px;
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }
    .add-border{
        border: $border-color;
    }

    .profile-image-upload-wrapper{
        // padding:30px;
        display: flex;
        align-items: center;
        .profile-image-display{
            border: 1px solid #3a3a3a;
            border-radius: 10px;
            margin: auto;
            justify-content: center;
            display: flex;
            .canvas{
                    height: 100%;
                    width: 100%;
                    border-radius: 5px;
            }
        }
        .upload-profile-image-button{
            padding: 8px 0px;
            margin: 0 auto;
            display: flex;
            margin-inline-start: 10px;
            flex-direction: column;
            .btn-wrapper{
                // margin-bottom: 8px;
                width: 130px;
                position: relative;
                margin: auto;
                display: inline-flex;
                justify-content: center;
                margin-bottom: 10px;
                
                button{
                  width:96%;
                }
            }
        }
    }

  .cover-image:hover{
    .cover-image-change{
      color: #fff !important;
      background-color: #007bff;
      border-color: #007bff;
      border-radius:0.25rem;
    }
  }
  input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position:relative;
}
input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block !important;
  width: 22px !important;
  height: 21px !important;
  margin-top: 5px !important;
  margin-inline-start: -1px !important;
  border: $border-color !important;
  border-radius: 0.25em !important;
  background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue !important;
  position: absolute !important;
  font-size: 16px !important;
  line-height: 1 !important;
  transition: all 0.2s !important;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px !important;
  padding-top: 2px !important;
}

.helper-tag{
    color: #6c6c6c;
    font-size: 14px;
    margin-top: 7px;
    display: inline-block;
    padding-inline-start:4px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
</style>